module.exports = __webpack_public_path__ + "img/11_16.9fc52447.png";